var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect } from "react";
import { TextButton } from "@tfo/common";
import { CircularProgress } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import React from 'react';
import { QRPrompt } from './QrPrompt';
import { LoginType } from "../../models/Enums";
const SESSION_STATES = {
    Login: "Login",
    Active: "Active",
    Pending: "Pending",
    Expired: "Expired",
};
export const BankId = ({ cancelBankIdSession, authenticateEncryptedData, startAuthOnDisplay, collectBankId, authBankId, onReset, qrCodeBankId }) => {
    const intl = useIntl();
    const initialQRSessionData = {
        protectedOrderRef: '',
        protectedQrState: '',
        qrCode: '',
    };
    const [qrSessionData, setQrSessionData] = useState(initialQRSessionData);
    const [sessionStatus, setSessionStatus] = useState(SESSION_STATES.Login);
    const [statusMessage, setStatusMessage] = useState('');
    const [qrCode, setQrCode] = useState('');
    useEffect(() => {
        createAuthenticationOrder(false);
    }, []);
    const createAuthenticationOrder = (onSameDevice) => __awaiter(void 0, void 0, void 0, function* () {
        authBankId(onSameDevice)
            .then(resp => {
            if (resp.launchUrl) {
                window.location.href = resp.launchUrl;
            }
            if (!resp.protectedOrderRef)
                return;
            checkBankIdTransaction(resp.protectedOrderRef, 0);
            if (onSameDevice) {
                cancelBankIdSession(qrSessionData.protectedOrderRef);
                setSessionStatus(SESSION_STATES.Pending);
            }
            else {
                setQrSessionData({ protectedOrderRef: resp.protectedOrderRef, protectedQrState: resp.protectedQrStartState, qrCode: resp.qrCode });
                setQrCode(resp.qrCode);
                setSessionStatus(SESSION_STATES.Active);
            }
        }).catch(err => console.log(err));
    });
    const checkBankIdTransaction = (protectedOrderRef, attempt) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield collectBankId(protectedOrderRef, attempt);
        if (response.completionData) {
            resetData();
            authenticateEncryptedData(response.completionData);
            return;
        }
        setStatusMessage(response.statusMessage);
        switch (response.hintCode) {
            case "OutstandingTransaction":
                setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                    checkBankIdTransaction(protectedOrderRef, attempt);
                }), 2000);
                break;
            case "UserSign":
                setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                    checkBankIdTransaction(protectedOrderRef, attempt);
                }), 2000);
                break;
            case "StartFailed":
                setSessionStatus(SESSION_STATES.Expired);
                break;
            default:
                break;
        }
    });
    const resetData = () => {
        cancelBankIdSession(qrSessionData.protectedOrderRef);
        setQrSessionData(initialQRSessionData);
        setSessionStatus(SESSION_STATES.Login);
        if (onReset) {
            onReset(LoginType.None);
        }
    };
    return (React.createElement("div", { className: "bankId-container" },
        React.createElement("div", { className: "collect-container" }, statusMessage.length < 1 ?
            React.createElement("div", { className: 'progressIcon' },
                React.createElement(CircularProgress, { style: { color: '#009B48' } })) :
            React.createElement(React.Fragment, null,
                sessionStatus === SESSION_STATES.Active &&
                    React.createElement(QRPrompt, { qrCode: qrCode, setQrCode: setQrCode, protectedQrState: qrSessionData.protectedQrState, qrCodeBankId: qrCodeBankId }),
                React.createElement("div", { className: "status-message" },
                    React.createElement(FormattedMessage, { id: `bankid.${statusMessage}` })))),
        sessionStatus === SESSION_STATES.Active && React.createElement(TextButton, { onClick: () => createAuthenticationOrder(true), className: "auth-same-device-button", secondary: true }, intl.formatMessage({ id: 'bankid.openOnThisDeviceButton' })),
        sessionStatus === SESSION_STATES.Expired && React.createElement(TextButton, { onClick: () => createAuthenticationOrder(false), className: "auth-same-device-button", secondary: true }, intl.formatMessage({ id: 'bankid.tryAgainButton' })),
        React.createElement("div", { className: "abort-container" },
            React.createElement(TextButton, { onClick: resetData, className: "abort-button", secondary: true }, intl.formatMessage({ id: 'bankid.cancelButton' })))));
};
